export default __webpack_public_path__ + "static/media/logo-escuro.0665d72f.png";